import { Truck, MapPin, ArrowRight } from 'lucide-react'
import { MockShell } from './MockShell'

/** Hero mock: the quote workspace at a glance. */
export function QuoteMock() {
  return (
    <MockShell title="app.routenroute.com / bahalar / Q-2417">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_280px]">
        {/* Main panel */}
        <div className="p-5 lg:p-6 border-r border-border">
          {/* Title row */}
          <div className="flex items-center justify-between gap-4 mb-5">
            <div>
              <p className="text-overline text-muted-foreground mb-1">Baha · Q-2417</p>
              <h4 className="text-h2 text-foreground">
                Acme Frozen Foods — Rotterdam → Warsaw
              </h4>
            </div>
            <span className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-[hsl(var(--status-waiting-bg))] text-[hsl(var(--status-waiting-text))] border border-[hsl(var(--status-waiting-border))]">
              Müşderä garaşylýar
            </span>
          </div>

          {/* Scenario tabs */}
          <div className="flex items-center gap-1 border-b border-border mb-4">
            {[
              { l: 'Göni', active: true },
              { l: 'Geçiş · Berlin', active: false },
              { l: 'Bölünen · 2 ulag', active: false },
            ].map((t) => (
              <button
                key={t.l}
                className={
                  'px-3 py-2 text-[12px] font-medium -mb-px border-b-2 ' +
                  (t.active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground')
                }
              >
                {t.l}
              </button>
            ))}
            <button className="px-2 py-2 text-[12px] text-muted-foreground">+</button>
          </div>

          {/* Route */}
          <div className="rounded-xl border border-border p-4 mb-4 bg-muted/30">
            <div className="flex items-center gap-3 text-[13px]">
              <MapPin className="w-3.5 h-3.5 text-primary shrink-0" />
              <span className="font-medium">Rotterdam, NL</span>
              <ArrowRight className="w-3 h-3 text-muted-foreground" />
              <span className="font-medium">Warsaw, PL</span>
              <span className="ml-auto text-muted-foreground tnum">1,240 km · 14 sag</span>
            </div>
            <div className="mt-3 h-1.5 rounded-full bg-border overflow-hidden">
              <div className="h-full w-2/3 bg-primary" />
            </div>
            <div className="mt-2 flex items-center justify-between text-[11px] text-muted-foreground">
              <span>Ýüklemek dş 06:00</span>
              <span>Geler sş 20:00</span>
            </div>
          </div>

          {/* Calculation lines */}
          <div className="rounded-xl border border-border overflow-hidden">
            <div className="px-4 py-2 border-b border-border bg-muted/30 text-overline text-muted-foreground">
              Hasaplama
            </div>
            <div className="divide-y divide-border text-[13px]">
              {[
                ['Ýangyç · 320 L @ €1.62', '518.40'],
                ['Paçlar · DE + PL', '184.00'],
                ['Sürüji · 2 gün', '420.00'],
                ['Rugsatlar we tölegler', '36.00'],
              ].map(([k, v]) => (
                <div
                  key={k as string}
                  className="px-4 py-2.5 flex items-center justify-between"
                >
                  <span className="text-muted-foreground">{k}</span>
                  <span className="tnum text-foreground">€ {v}</span>
                </div>
              ))}
              <div className="px-4 py-2.5 flex items-center justify-between bg-muted/30 font-medium">
                <span>Çykdajy</span>
                <span className="tnum">€ 1,158.40</span>
              </div>
              <div className="px-4 py-2.5 flex items-center justify-between">
                <span className="text-muted-foreground">Marja · 22%</span>
                <span className="tnum text-positive">+ €254.85</span>
              </div>
              <div className="px-4 py-3 flex items-center justify-between bg-primary/5 font-semibold">
                <span>Teklip baha</span>
                <span className="tnum text-primary">€ 1,413.25</span>
              </div>
            </div>
          </div>
        </div>

        {/* Side rail */}
        <div className="p-5 lg:p-6 bg-muted/20">
          <p className="text-overline text-muted-foreground mb-2">Müşderi</p>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold text-[13px]">
              AF
            </div>
            <div className="min-w-0">
              <p className="text-[13px] font-medium truncate">Acme Frozen Foods</p>
              <p className="text-[11px] text-muted-foreground truncate">
                ops@acmefrozen.nl
              </p>
            </div>
          </div>

          <p className="text-overline text-muted-foreground mb-2">Ulag</p>
          <div className="flex items-center gap-2.5 mb-5 text-[13px]">
            <Truck className="w-3.5 h-3.5 text-muted-foreground" />
            <span>Sowadyjy · 33 EP</span>
          </div>

          <p className="text-overline text-muted-foreground mb-2">Hereket</p>
          <ul className="space-y-2 text-[12px] text-muted-foreground">
            <li>
              <span className="text-foreground">Mira</span> Geçiş · Berlin goşdy
            </li>
            <li>
              <span className="text-foreground">Ikay</span> marjany 22%-e goýdy
            </li>
            <li>Baha müşderä iberildi · 2 sag öň</li>
          </ul>
        </div>
      </div>
    </MockShell>
  )
}
